import React from 'react'

const PhysicalDetailTable = () => {
    return (
        <div className='flex flex-col justify-center items-center xl:flex-row  xl:gap-10 pt-6'>
            <div className="flex flex-col w-full lg:w-3/5 xl:w-1/2">
                <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="py-2 inline-block min-w-full sm:px-6 lg:px-8">
                        <div className="overflow-hidden">
                            <table className="min-w-full">
                                <thead className="border border-black">
                                    <tr>
                                        <th scope="col" className="table_head_mini">
                                            Particulars
                                        </th>
                                        <th scope="col" className="table_head_mini">
                                            Inch
                                        </th>
                                        <th scope="col" className="table_head_mini">
                                            Inch
                                        </th>
                                        <th scope="col" className="table_head_mini">
                                            Inch
                                        </th>
                                        <th scope="col" className="table_head_mini">
                                            Inch
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className='border border-black'>
                                    <tr>
                                        <td className="px-4 py-2 whitespace-nowrap text-sm font-medium text-gray-900 border border-black">Weight(Kg)</td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                    </tr>
                                    <tr className="bg-white ">
                                        <td className="px-4 py-2 whitespace-nowrap text-sm font-medium text-gray-900 border border-black">Chest</td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                    </tr>
                                    <tr className="bg-white">
                                        <td className="px-4 py-2 whitespace-nowrap text-sm font-medium text-gray-900 border border-black">Arms</td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                    </tr>
                                    <tr className="bg-white">
                                        <td className="px-4 py-2 whitespace-nowrap text-sm font-medium text-gray-900 border border-black">Waist</td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                    </tr>
                                    <tr className="bg-white ">
                                        <td className="px-4 py-2 whitespace-nowrap text-sm font-medium text-gray-900 border border-black">Shoulder</td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                    </tr>
                                    <tr className="bg-white ">
                                        <td className="px-4 py-2 whitespace-nowrap text-sm font-medium text-gray-900 border border-black">Height(Ft.)</td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex flex-col w-full lg:w-3/5 xl:w-1/2">
                <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="py-2 inline-block min-w-full sm:px-6 lg:px-8">
                        <div className="overflow-hidden">
                            <table className="min-w-full">
                                <thead className="border border-black">
                                    <tr>
                                        <th scope="col" className="table_head_mini">
                                            Particulars
                                        </th>
                                        <th scope="col" className="table_head_mini">
                                            Inch
                                        </th>
                                        <th scope="col" className="table_head_mini">
                                            Inch
                                        </th>
                                        <th scope="col" className="table_head_mini">
                                            Inch
                                        </th>
                                        <th scope="col" className="table_head_mini">
                                            Inch
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className='border border-black'>
                                    <tr>
                                        <td className="px-4 py-2 whitespace-nowrap text-sm font-medium text-gray-900 border border-black">Neck</td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                    </tr>
                                    <tr className="bg-white ">
                                        <td className="px-4 py-2 whitespace-nowrap text-sm font-medium text-gray-900 border border-black">Fore Arms</td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                    </tr>
                                    <tr className="bg-white">
                                        <td className="px-4 py-2 whitespace-nowrap text-sm font-medium text-gray-900 border border-black">Hip</td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                    </tr>
                                    <tr className="bg-white">
                                        <td className="px-4 py-2 whitespace-nowrap text-sm font-medium text-gray-900 border border-black">Thigh</td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                    </tr>
                                    <tr className="bg-white ">
                                        <td className="px-4 py-2 whitespace-nowrap text-sm font-medium text-gray-900 border border-black">Calves</td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                    </tr>
                                    <tr className="bg-white ">
                                        <td className="px-4 py-2 whitespace-nowrap text-sm font-medium text-gray-900 border border-black"></td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                        <td className="table_body_mini">
                                            <input type="text" className='physical_input_mini' />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PhysicalDetailTable;